import React, { type FunctionComponent, type PropsWithChildren, type ComponentClass, createElement, type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { type TextProps, SupText } from "../../../../components/UI/Text";

export interface BreadcrumbProps<P extends object> extends PropsWithChildren {
  className?: string;
  icon?: JSX.Element;
  fontStyle?: TextProps["variant"];
  link?: P;
  linkComponent?: FunctionComponent<P> | ComponentClass<P> | "a";
}

export function SupBreadcrumb<P extends object>({ className, icon, fontStyle = "button", link, linkComponent = "a", children }: BreadcrumbProps<P>) {
  const breadcrumbClassName = twMerge("sup-breadcrumb inline-flex gap-2 items-center", className);

  const content = (
    <>
      {icon}
      <SupText as="span" variant={fontStyle} className="whitespace-nowrap">
        {children}
      </SupText>
    </>
  );

  if (link) {
    return createElement(linkComponent, { className: breadcrumbClassName, ...link }, content);
  }

  return <span className={breadcrumbClassName}>{content}</span>;
}
